import React from "react";

const metrics = [
  { value: "1,000,000+", label: "candidatos en nuestra red" },
  { value: "15,000+", label: "colocaciones exitosas" },
  { value: "89%", label: "reducción en tiempo de contratación" },
  { value: "500+", label: "empresas confían en nosotros" },
];

const testimonials = [
  {
    name: "María Rodríguez",
    role: "Gerente de RRHH",
    company: "Empresa del sector Retail",
    quote:
      "Pasamos de tomar 45 días en promedio para cubrir una vacante a solo 18. La IA del ATS nos cambió el proceso por completo.",
    badge: "60% menos tiempo",
  },
  {
    name: "Carlos Jiménez",
    role: "Director de Talento",
    company: "Empresa del sector Finanzas",
    quote:
      "La integración de psicometría dentro del ATS nos permitió mejorar drásticamente la calidad de las contrataciones.",
    badge: "89% aceptación de oferta",
  },
  {
    name: "Andrea Vargas",
    role: "Gerente General",
    company: "Empresa del sector Logística",
    quote:
      "Publicar en +17 job boards desde una sola pantalla nos triplicó la cantidad de candidatos calificados.",
    badge: "3x más aplicaciones",
  },
];

const ResultsSocialProof: React.FC = () => {
  return (
    <section id="resultados" className="bg-white" style={{ paddingTop: "80px", paddingBottom: "80px" }}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2
            className="font-exo font-bold mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 3rem)", color: "#1A1A2E" }}
          >
            Resultados reales de empresas reales
          </h2>
        </div>

        {/* Metrics */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-16">
          {metrics.map((m) => (
            <div
              key={m.label}
              className="rounded-2xl p-6 md:p-8 text-center border"
              style={{ background: "#F8F7FF", borderColor: "rgba(98, 10, 226, 0.1)" }}
            >
              <div
                className="font-exo font-bold mb-2"
                style={{ color: "#620AE2", fontSize: "clamp(1.75rem, 3vw, 2.5rem)" }}
              >
                {m.value}
              </div>
              <div className="text-xs md:text-sm text-muted-foreground leading-tight">
                {m.label}
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <article
              key={t.name}
              className="bg-white rounded-2xl p-6 border shadow-sm hover:shadow-lg transition-all"
              style={{ borderColor: "rgba(98, 10, 226, 0.1)" }}
            >
              <span
                className="inline-block px-3 py-1 rounded-full text-xs font-bold mb-4"
                style={{ background: "rgba(0, 201, 212, 0.15)", color: "#0D9488" }}
              >
                {t.badge}
              </span>
              <p className="text-sm leading-relaxed mb-5" style={{ color: "#1A1A2E" }}>
                "{t.quote}"
              </p>
              <div className="border-t pt-4">
                <div className="font-bold text-sm" style={{ color: "#1A1A2E" }}>
                  {t.name}
                </div>
                <div className="text-xs text-muted-foreground">
                  {t.role} · {t.company}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResultsSocialProof;
